export default arr =>
  arr.reduce((str, val, i) => {
    if (i === 0) return val;
    return `${str}, ${val}`;
  }, '');
